import { render, staticRenderFns } from "./LoaderSpinner.vue?vue&type=template&id=04797c52&scoped=true&"
import script from "./LoaderSpinner.vue?vue&type=script&lang=ts&"
export * from "./LoaderSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderSpinner.vue?vue&type=style&index=0&id=04797c52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04797c52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04797c52')) {
      api.createRecord('04797c52', component.options)
    } else {
      api.reload('04797c52', component.options)
    }
    module.hot.accept("./LoaderSpinner.vue?vue&type=template&id=04797c52&scoped=true&", function () {
      api.rerender('04797c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LoaderSpinner.vue"
export default component.exports